<script lang="ts">
    import { mdiDomain, mdiAccount } from "@mdi/js"
    import Icon from "./../Icon.svelte"

    export let value: any
</script>

<Icon path="{value === 'person' ? mdiAccount : mdiDomain}" size="24px" />
